import { warn, error } from '../application/console'
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from '../utils/object'

// FIXME START: deduplicate this by resolving the circular dependency and replace with "import { queryString, } from 'utils/window';"
function dashDelimitedToCamelCase(string) {
  return string.replace(/-([a-z])/g, group => group[1].toUpperCase())
}
function decode(s) {
  const plus = /\+/g //Regex for replacing addition symbol with a space
  return decodeURIComponent(s.replace(plus, ' '))
}
export function deserializeQueryString(inputQuery = window.location.search, queryStringObj = {}) {
  const search = /([^&=]+)=?([^&]*)/g
  let query = inputQuery.substring(1)
  let matches = search.exec(query)
  while (matches) {
    let [fullKey, onlyKey, rawValue] = matches
    let isOnlyKey = fullKey === onlyKey
    let value = isOnlyKey ? true : decode(rawValue)
    let key = dashDelimitedToCamelCase(onlyKey)
    queryStringObj[key] = value
    matches = search.exec(query)
  }
  return queryStringObj
}
const queryString = deserializeQueryString()
// FIXME END

const { debugUnsafeFn } = queryString

export function noop() {}

export function makeSafeFn(unsafeFn = noop, opt = { isMute: false }) {
  const unsafeFnName = unsafeFn.name
  function safeFnWrapper() {
    // eslint-disable-line consistent-return
    const args = arguments
    if ([unsafeFnName, true].includes(debugUnsafeFn)) {
      return unsafeFn.apply(this, args)
    }
    try {
      return unsafeFn.apply(this, args)
    } catch (ex) {
      if (!opt.isMute) {
        warn(
          `makeSafeFn: failed to invoke '${unsafeFnName || unsafeFn}'`,
          {
            unsafeFn,
            args,
            exception: ex,
          },
          `\n${ex.stack}`
        )
      }
    }
  }
  safeFnWrapper.invoke = function callWithNullBinding(...args) {
    return safeFnWrapper.call(null, ...args)
  }
  return safeFnWrapper
}

export function areAllFunctions(...possiblyFunctions) {
  return !possiblyFunctions.some(makeSafeFn(possiblyFn => !(possiblyFn instanceof Function)))
}

export function once(fn, ...args) {
  var result // has to be var to avoid DMZ!
  const originalFn = fn
  const onceRunner = function() {
    if (fn && fn instanceof Function) {
      result = fn(...args)
      fn = null // eslint-disable-line no-param-reassign
    }
    return result
  }
  onceRunner.reset = function enableRunningOnceAgain() {
    fn = originalFn // eslint-disable-line no-param-reassign
    return onceRunner
  }
  return onceRunner
}

export function allTrue(...predicates) {
  return predicates.reduce((prev, current) => prev && current)
}

export function memoizeFirstCall(getterName, fn, ...args) {
  let memoizedObj = null
  return {
    get [getterName]() {
      memoizedObj = memoizedObj || fn.apply(null, args)
      return memoizedObj
    },
  }
}
export const identity = it => it

export function throwIfMissingArgument() {
  const missingArgumentMessage = 'Missing argument!'
  error(missingArgumentMessage, this)
  throw new Error(missingArgumentMessage)
}

const fn = Object.assign(makeEmptyObj(), {
  noop,
  once,
  allTrue,
  makeSafeFn,
  areAllFunctions,
  memoizeFirstCall,
  identity,
  throwIfMissingArgument,
})

export function isFunction(functionToCheck) {
  return typeof functionToCheck === 'function'
}

registerUtils({ fn })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/fn.js